/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class ClearCheckMarkIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g
        id="checkmark"
        opacity="0.791949728"
      >
        <path
          d="M4.53164 11.8213C4.15817 11.4478 3.55264 11.4478 3.17917 11.8213C2.80569 12.1948 2.80569 12.8003 3.17917 13.1738L8.816 18.8106C9.18948 19.1841 9.795 19.1841 10.1685 18.8106C10.542 18.4372 10.542 17.8316 10.1685 17.4582L4.53164 11.8213Z"
        />
        <path
          d="M20.8223 8.23558C21.2129 7.84505 21.2129 7.21189 20.8223 6.82136C20.4318 6.43084 19.7987 6.43084 19.4081 6.82136L8.82007 17.4094C8.42955 17.7999 8.42955 18.4331 8.82007 18.8236C9.2106 19.2142 9.84376 19.2142 10.2343 18.8236L20.8223 8.23558Z"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(ClearCheckMarkIcon);
Icon.displayName = 'ClearCheckMarkIcon';
export default Icon;
